






























































// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';

// store
import { useStore } from '@/store';

//hook
import { useNotify } from '@/vue3/hooks/notifyHook';

// models
import { GeoRecord } from '@/vue3/api/models';

// services
import { useService } from '@/vue3/api/services';

// components
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

// primevue
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Confirm from '@/vue3/components/Confirm.vue';
import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
    components: {
        Button,
        Dialog,
        Confirm,
        ProgressSpinner,
        EditorDropdown,
    },
    props: {
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        clearGeoRecord: {
            type: Function,
            default: () => {},
        },
        updateGeoRecordLayer: {
            type: Function,
            default: () => {},
        },
        categorySummaries: {
            type: Array,
            default: () => [],
        },
    },
    setup(props: any, vm: any) {
        // store
        const store = useStore();

        // services
        const { createGeoRecord, organizations, getAllOrganization } =
            useService();

        //hook
        const { errorToast } = useNotify();

        // refs
        const isOverlayGeoRecordDialogVisible = ref(false);
        const geoRecordArray = ref([]) as any;
        const files = ref() as any;
        const newGeoRecord = ref({} as GeoRecord);
        const featureCollection = ref() as any;
        const noOfGeoRecords = ref(0);
        const isLoading = ref(false);
        const organization = ref();

        // file reader
        const reader = new FileReader();

        // methods
        const readVectorDataFile = (e: any) => {
            files.value = e.target.files[0];
            reader.onload = (res: any) => {
                featureCollection.value = JSON.parse(res.currentTarget.result);
                if (featureCollection.value.features.length > 500) {
                    errorToast(
                        'No more than 100 geo records can be added at a time.',
                    );
                    return;
                }
                noOfGeoRecords.value = featureCollection.value.features.length;
                isOverlayGeoRecordDialogVisible.value = true;
                featureCollection.value.features.forEach((feature: any) => {
                    createdGeoRecord(feature);
                });
            };
            reader.onerror = (err) => window.console.log(err);
            reader.readAsText(files.value);
            e.target.value = '';
        };

        const createdGeoRecord = (feature: any) => {
            if (feature.properties.title !== '') {
                newGeoRecord.value.title = feature.properties.title;
            }
            if (feature.properties.geoRecordCategoryId !== 0) {
                newGeoRecord.value.geoRecordCategoryId =
                    feature.properties.geoRecordCategoryId;
            }
            newGeoRecord.value.isFill = true;
            newGeoRecord.value.geometry = feature.geometry;
            newGeoRecord.value.accountId = store.getters.account.id;
            newGeoRecord.value.courseSchemaId =
                store.getters.currentCourseSchema.id;
            newGeoRecord.value.organizationId = organization.value;
            geoRecordArray.value.push(newGeoRecord.value);
            newGeoRecord.value = {} as GeoRecord;
        };

        const confirmDecline = () => {
            isOverlayGeoRecordDialogVisible.value = false;
            geoRecordArray.value = [];
        };

        const confirmUpload = () => {
            isOverlayGeoRecordDialogVisible.value = false;
            geoRecordArray.value.forEach((geoRecord: any) => {
                var geoRecordCategory = props.categorySummaries.filter(
                    (x) => x.id === geoRecord.geoRecordCategoryId,
                );
                if (geoRecordCategory.length > 0) {
                    geoRecord.color = geoRecordCategory[0].color;
                }
                addGeoRecord(geoRecord);
            });
            props.clearGeoRecord();
            geoRecordArray.value = [];
        };

        const addGeoRecord = async (geoRecord: any) => {
            isLoading.value = true;
            const createdGeoRecord = await createGeoRecord(
                geoRecord as GeoRecord,
            );
            props.updateGeoRecordLayer(createdGeoRecord);
            isLoading.value = false;
        };

        // lifecycle
        onMounted(async () => {
            await getAllOrganization();
        });

        return {
            readVectorDataFile,
            isOverlayGeoRecordDialogVisible,
            confirmUpload,
            confirmDecline,
            noOfGeoRecords,
            organizations,
            isLoading,
            newGeoRecord,
            organization,
        };
    },
});
